module.exports = __webpack_public_path__ + "img/00-0.4d739db0.jpg";